import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { KnowledgeBaseFileDetails } from '@features/Admin/KnowledgeBase/ui/KnowledgeBaseFileDetails';
import type { CampaignKnowledgeBaseFile } from '@features/Admin/KnowledgeBase/model/types';

type Props = {
  file: CampaignKnowledgeBaseFile;
  onClose: () => void;
};

export const AgentFileDetailsDialog: React.FC<Props> = ({ file, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('adminMainPage.agent.advancedSettingsFiles.details')}</DialogTitle>
      <DialogContent dividers>
        <KnowledgeBaseFileDetails file={file} isAvailable={file.isEnabled} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('adminMainPage.agent.advancedSettingsFiles.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
